export default function calculateSpeed(bps: number, factor: number) {
    const bpm = bps * 60;
    return (Math.sqrt(38400000 * (bpm / (factor)) + 1687696201) - 45341) / 19200;
}
